var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "create",
    d: "M61.456,10.544A36,36,0,0,0,10.544,61.456a2.105,2.105,0,0,0,1.853.585h0l17.044-2.985a2.109,2.109,0,0,0,1.128-.586l27.41-27.41a2.109,2.109,0,0,0,0-2.983L43.921,14.017a2.109,2.109,0,0,0-2.983,0l-27.41,27.41a2.109,2.109,0,0,0-.586,1.128L10.717,55.262A31.784,31.784,0,1,1,36,67.781,2.109,2.109,0,1,0,36,72,36,36,0,0,0,61.456,10.544ZM16.4,47.28,24.719,55.6,14.632,57.368ZM29.079,54,25.033,49.95,49.46,25.523l4.046,4.046Zm13.35-35.5,4.048,4.048L22.05,46.967,18,42.919Z",
    fill: "#157af6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.4509b402.svg";
export { ForwardRef as ReactComponent };